import { FormattedMessage } from "react-intl";
import { HEADER_LINKS } from "../../constants/constants";

interface LinkButtonProps {
  href: string;
  messageId: string;
}

function LinkButton({ href, messageId }: LinkButtonProps) {
  return (
    <a
      href={href}
      className=" application-feedback__link"
      target="_blank"
      rel="noopener noreferrer"
      role="button"
    >
      <FormattedMessage id={messageId} />
    </a>
  );
}

interface Props {
  isUserExternal: boolean;
}

function TheHeaderFeedback({ isUserExternal }: Props) {
  return (
    <div>
      <LinkButton
        href={HEADER_LINKS.INCIDENT_REPORT_URL}
        messageId="incident"
      />
      {!isUserExternal && (
        <LinkButton
          href={HEADER_LINKS.REQUEST_FOR_CHANGE_URL}
          messageId="requestForChange"
        />
      )}
    </div>
  );
}

export default TheHeaderFeedback;
